module.exports = __webpack_public_path__ + "static/media/0017.42f7db4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/handles/H48104/Decors_colored/N06_black/0017.png
// module id = 2381
// module chunks = 0